import BULK_PRODUCT from "./bulkProductAction";
import UPDATE_VENDOR_FIELD from "./updateVendorField";

export default BULK_PRODUCT;
export { UPDATE_VENDOR_FIELD };
